import { ThemeProvider } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import 'proj4leaflet';

import DownloadMapDataPopup from './Features/Download/components/downloadMapDataPopup';
import SettingsPopup from './Features/Settings/components/settingsPopup';
import ChangeLayerPopup from './Features/LayerChange/components/changeLayerPopup';
import LocationInfoPopup from './Features/LocationInfo/components/LocationInfoPopup';
import SearchPlacesPopup from './Features/Search/components/searchPlacesPopup';
import InstantNotifierProvider from './Lib/Notifier/instantNotifierContext';
import SnackBarInstantNotifier from './Lib/UI/Components/SnackBarInstantNotifier';
import MapTopToolBar from './Features/Toolbar/components/MapTopToolBar';
import MapMainToolBar from './Features/Toolbar/components/mapMainToolBar';
import MainMap from './Features/MainMap/components/MainMap';
import SettingsProvider from './Settings/context';
import MapCurrentLocationMarker from './Features/MapComponents/Leaflet/Layers/MapCurrentLocationMarker';
import MapLocationTracking from './Features/MapComponents/Leaflet/Behaviours/MapLocationTracking';
import InitialisingLogButton from './Features/Log/InitialisingLogButton';
import { InMemoryLog } from './Lib/Log/InMemoryLog';
import useApp from './useApp';
import useMainMap from './Features/MainMap/hooks/useMainMap';

import theme from './theme';
import './App.css';


const log = new InMemoryLog(500);

function App() {

  const app = useApp(log);
  const mainMap = useMainMap(app.settingsService.config, app.mapStateService, app.settingsService.settings, app.settingsService.config.mapSnapshotGenerator, app.tileCache, app.cacheSeeders, log);

  return (

      <ThemeProvider theme={theme}>

        <SettingsProvider config={app.settingsService.config} settings={app.settingsService.settings} log={log}>

          <InstantNotifierProvider service={app.instantNotifierService}>

            <div className="App">

            {!app.isInitialised &&
              <InitialisingLogButton log={log} />
            }

            {!!app.isInitialised && 
              <>
                <MainMap state={mainMap}>

                  <MapTopToolBar 
                    locationTracker={app.locationTracker}
                    deviceCompass={app.deviceCompass}
                    locationInfoAction={mainMap.openLocationInfoAction}
                    log={log}
                  />

                  <MapLocationTracking 
                    locationTracker={app.locationTracker}
                  />

                  <MapCurrentLocationMarker 
                    locationTracker={app.locationTracker}
                    deviceCompass={app.deviceCompass}
                    withHeadingIconUrl={app.settingsService.config.icons.currentLocationWithHeading}
                    noHeadingIconUrl={app.settingsService.config.icons.currentLocationNoHeading}
                  />

                  <MapMainToolBar 
                    currentTitleLayer={mainMap.currentTileLayer} 
                    settingsAction={mainMap.openSettingsAction}
                    downloadAction={mainMap.openDownloadDataAction}
                    searchAction={mainMap.openSearchPlacesAction}
                    changeLayerAction={mainMap.openChangeLayerAction}
                    locationTracker={app.locationTracker}
                  />

                {mainMap.currentTileLayer && mainMap.tileCacheSeeder && 
                  <DownloadMapDataPopup action={mainMap.openDownloadDataAction} tileCacheSeeder={mainMap.tileCacheSeeder} snapshotGen={mainMap.mapSnapshotGenerator}/>
                }

                  <SearchPlacesPopup action={mainMap.openSearchPlacesAction} placeSearchService={app.placeSearchService} placeHistoryService={app.placeHistoryService} maxResults={app.settingsService.config.ui.placeSearchMaxResults}/>
                  <SettingsPopup action={mainMap.openSettingsAction} service={app.settingsService} tileCache={app.tileCache}/>
                  <ChangeLayerPopup action={mainMap.openChangeLayerAction} layers={mainMap.tileLayers} currentLayer={mainMap.currentTileLayer}/>
                  <LocationInfoPopup action={mainMap.openLocationInfoAction} locationTracker={app.locationTracker} />

                </MainMap>
              </>
            }

              <SnackBarInstantNotifier
                autoHideDurationMs={app.settingsService.config.ui.notifierAutoHideDurationMs}
              />

            </div>

          </InstantNotifierProvider>

        </SettingsProvider>

      </ThemeProvider>

  );
}

export default App;